import Homepage from "app/pages/home";

export default {
  home: { component: Homepage, exact: false }
};

export { default as ErrorPage } from "app/pages/error";

export const DefaultPage = Homepage;
